import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Admin, AdminDto} from './admin';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Page, PageDto} from '../core/pagination/page';
import {PageRequest} from '../core/pagination/page-request';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private http = inject(HttpClient);

  getAdminMe$(): Observable<Admin> {
    return this.http
      .get<AdminDto>(`${environment.apiUrl}/admins/me`)
      .pipe(map(dto => Admin.deserialize(dto)));
  }

  getAdmins$(pageRequest: PageRequest<Admin>): Observable<Page<Admin>> {
    return this.http
      .post<PageDto<AdminDto>>(`${environment.apiUrl}/admins/page`, pageRequest)
      .pipe(map(pageDto => new Page(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => Admin.deserialize(dto)),
      )));
  }

  postAdmin$(regioverantwoordelijke: Admin): Observable<Admin> {
    return this.http
      .post<AdminDto>(`${environment.apiUrl}/admins`, regioverantwoordelijke)
      .pipe(map(dto => Admin.deserialize(dto)));
  }

  getAdminById$(id: string): Observable<Admin> {
    return this.http.get<AdminDto>(`${environment.apiUrl}/admins/${id}`)
      .pipe(map(dto => Admin.deserialize(dto)));
  }

  updateAdmin$(admin: Admin): Observable<Admin> {
    return this.http.put<AdminDto>(`${environment.apiUrl}/admins/${admin.getId()}`, admin)
      .pipe(map(dto => Admin.deserialize(dto)));
  }

  deleteAdmin$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/admins/${id}`);
  }
}
